export const MMDDYYYY = 'MM/DD/YYYY';
export const DDMMYYYY = 'DD/MM/YYYY';
export const YYYYMMDD = 'YYYY/MM/DD';
export const YYYY_MM_DD = 'YYYY-MM-DD';
export const VIEW = {
    MMDDYYYY: 'MM/dd/yyy'
};

export const dateFormats = [
    {
        name: 'MM/DD/YYYY',
        value: MMDDYYYY
    },
    {
        name: 'DD/MM/YYYY',
        value: DDMMYYYY
    },
    {
        name: 'YYYY/MM/DD',
        value: YYYYMMDD
    }
];
